'use es6';

import { createSelector } from 'reselect';
import ModuleCompatibilityTagTypes from 'marketplace-lib/constants/ModuleCompatibilityTagTypes';
import * as RefundStatusTypes from 'marketplace-lib/constants/RefundStatusTypes';
import GoodSubTypes from '../constants/GoodSubTypes';
import { getPortal } from './auth';

var getGoodDetails = function getGoodDetails(state) {
  return state.goodDetails;
};

var getTransactionId = function getTransactionId(state) {
  return getGoodDetails(state).get('transactionId');
};

var getHasReviewed = function getHasReviewed(state) {
  return getGoodDetails(state).get('hasReviewed');
};

var getCustomerPurchaseInfo = function getCustomerPurchaseInfo(state) {
  return getGoodDetails(state).get('customerPurchaseInfo');
};

export var getCanReview = createSelector([getTransactionId, getHasReviewed], function (transactionId, hasReviewed) {
  return !!transactionId && !hasReviewed;
});
export var getIsGoodProvider = createSelector([getPortal, getGoodDetails], function (portal, goodDetails) {
  return portal.portal_id === goodDetails.get('providerPortalId');
});
export var getIsEmailGood = createSelector([getGoodDetails], function (goodDetails) {
  var goodSubType = goodDetails.get('subType');

  if (goodSubType === GoodSubTypes.EMAIL_TEMPLATES) {
    return true;
  }

  var customModuleCompatibilityTag = goodDetails.get('customModuleCompatibilityTag');

  if (goodSubType === GoodSubTypes.CUSTOM_MODULE && customModuleCompatibilityTag.size === 1 && customModuleCompatibilityTag.includes(ModuleCompatibilityTagTypes.COMPATIBLE_EMAIL)) {
    return true;
  }

  if (goodSubType === GoodSubTypes.PACKS && goodDetails.get('children').every(function (child) {
    return child.get('subType') === GoodSubTypes.EMAIL_TEMPLATES;
  })) {
    return true;
  }

  return false;
});
export var getIsRefunded = createSelector([getCustomerPurchaseInfo], function (customerPurchaseInfo) {
  return customerPurchaseInfo.getIn(['refund', 'status']) === RefundStatusTypes.SUCCEEDED;
});